import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import React from 'react';
import { FeedHeader } from '../feed-header/FeedHeader';
import { ProductGroup } from '@app/core/models/client';
import { createRoot, Root } from 'react-dom/client';

let productGroupPreviewInstanceId = 0;

@Component({
    selector: 'product-group-preview-react',
    templateUrl: './product-group-preview-react-container.component.html',
    styleUrls: ['./product-group-preview-react-container.component.scss'],
    standalone: true,
})
export class ProductGroupPreviewReactContainerComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  constructor() {}

  reactWrapperId: string;
  @Input() messageId?: string;
  @Input() productGroupName: ProductGroup['name'];
  @Input() showProductGroup: ProductGroup['hide_pg_wire_display_name'];
  @Input() productGroupDescription: ProductGroup['description'];
  @Input() bannerUrl: ProductGroup['branding']['banner_s3_url'];
  @Input() logoUrl: ProductGroup['branding']['icon_s3_url'];
  @Input() color: ProductGroup['branding']['color'];
  @Input() fdic?: ProductGroup['fdic'];
  @Input() showFDIC?: boolean;
  @Input() showBanner?: boolean;
  @Input() showLogo?: boolean;
  @Input() showTitleBar?: boolean;
  @Input() hideHamburger?: boolean;

  root: Root = null;
  ngOnInit() {
    // adding a messageId (if available) for experience preview pages (or it will only render on the first <Phone></Phone>)
    this.reactWrapperId = `product-group-preview-${this.messageId || ''}-${++productGroupPreviewInstanceId}`;
  }

  protected getRootDomNode() {
    const node = document.getElementById(this.reactWrapperId);
    return node;
  }

  ngOnDestroy(): void {
    this.root.unmount();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }
  protected render() {
    if (this.root) {
      this.root.render(
        React.createElement(FeedHeader, {
          productGroupDescription: this.productGroupDescription,
          showProductGroup: this.showProductGroup,
          productGroupName: this.productGroupName,
          bannerUrl: this.bannerUrl || '',
          logoUrl: this.logoUrl,
          color: this.color,
          isPreview: true,
          showFDIC: !!this.showFDIC,
          fdic: this.fdic || undefined,
          showBanner: this.showBanner,
          showLogo: this.showLogo,
          showTitleBar: this.showTitleBar,
          showMenu: !this.hideHamburger,
        }),
      );
    }
  }

  ngAfterViewInit(): void {
    const node = document.getElementById(this.reactWrapperId);
    this.root = createRoot(node);
    this.render();
  }
}
